<template>
  <el-drawer
  :title="$t('reservation.filters.filters')"
  :visible.sync="visible"
  :direction="direction"
  :before-close="handleClose"
  :size="width"
  @open="open">
  <div class="drawer__content scrollable only-y" :style="divHeight" >
    <el-form>
      <el-form-item>
        <el-button @click="resetFilters()" size="mini">{{ $t('reservation.filters.reset') }}</el-button>
      </el-form-item>
      <el-collapse v-model="activeName">
        <el-collapse-item :title="$t('reservation.filters.type')" name="1">
          <el-form-item>
            <el-row>
              <el-col>
               <el-checkbox v-model="active" :label="$t('reservation.filters.availableProduct')"></el-checkbox>
             </el-col>
           </el-row>
           <el-row :gutter="20">
             <el-col>
               <el-checkbox v-model="delayed" :label="$t('reservation.filters.inSupplyProduct')"></el-checkbox>
             </el-col>
           </el-row>
           <el-row :gutter="20">
             <el-col>
               <el-checkbox v-model="intent" :label="$t('reservation.filters.intent')"></el-checkbox>
             </el-col>
           </el-row>
           <el-row :gutter="20">
             <el-col>
               <el-checkbox v-model="completed" :label="$t('reservation.filters.completed')"></el-checkbox>
             </el-col>
           </el-row>
         </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('reservation.filters.status')" name="2">
          <el-form-item>
            <el-row>
              <el-col>
               <el-checkbox v-model="redFlag" :label="redLabel" ></el-checkbox>
             </el-col>
           </el-row>
           <el-row :gutter="20">
             <el-col>
               <el-checkbox v-model="yellowFlag" :label="yellowLabel" ></el-checkbox>
             </el-col>
           </el-row>
           <el-row :gutter="20">
             <el-col>
               <el-checkbox v-model="greenFlag" :label="greenLabel" ></el-checkbox>
             </el-col>
           </el-row>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('reservation.filters.rep')" name="3">
          <el-form-item >
            <el-checkbox-group v-model="salesRep">
              <el-row :gutter="20" v-for="sales_rep in filterUserWithRoleRep" :key="sales_rep.id">
                <el-col>
                  <el-checkbox :label="sales_rep.id">{{sales_rep.firstName}} {{sales_rep.lastName}}</el-checkbox>
                </el-col>
              </el-row>

            </el-checkbox-group>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('reservation.filters.customer')" name="4">
          <el-form-item >
            <selectCustomer :selectedCustomer="filters.customerId" @selected="setCustomerFilter"></selectCustomer>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('reservation.filters.customerClass')" name="4.1">
          <el-checkbox-group  v-model="checkedCustomerClasses" >
            <el-row :gutter="20" v-for="cclass in customerClasses" :key="cclass.id">
              <el-col>
                  <el-checkbox  :label="cclass.id">{{cclass.code}}</el-checkbox>
              </el-col>
            </el-row>
          </el-checkbox-group>
        </el-collapse-item>
        <el-collapse-item :title="$t('reservation.filters.product')" name="5">
          <el-form-item >
            <selectProduct :selectedProduct="filters.productId" @selected="setProductFilter"></selectProduct>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item :title="$t('reservation.filters.inventories')" name="6" v-if="isMultipleInventorySystem">
          <el-form-item >
            <selectInventory :selectedInventories="filters.inventories" :multiple="true" @selected="setInventoryFilter"></selectInventory>
          </el-form-item>
        </el-collapse-item>
      </el-collapse>



   </el-form>
  </div>
</el-drawer>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import moment from 'moment';
import selectCustomer from '@/components/customer/select-customer'
import selectProduct from '@/components/product/select-product'
import selectInventory from '@/components/inventory/select-inventory'

export default {
  name: 'reservation-filter',
	props: {
    visible : {type : Boolean},
    direction : {
      type : String,
      default : "rtl" //rtl / ltr / ttb / tbb
    }
	},
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      activeName : "1"
    };
  },components: {
    selectCustomer,
    selectProduct,
    selectInventory
  },
  watch : {

  },
	methods: {
    open(){
      this.fetchCustomerClasses();
    },
    handleClose(){
      this.$emit('close');
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    ...mapActions('controlData',['fetchCustomerClasses']),
    ...mapActions('reservations',['setFilterActive', 'setFilterIntent', 'setFilterCompleted','setFilterInactive','setFilterRedFlag','setFilterYellowFlag','setFilterGreenFlag','setFilterSalesRep','setFilterDelayed','resetFilters','setCustomerFilter','setProductFilter','setInventoryFilter', 'changeCustomerClassFilter']),
    ...mapActions('users', ['fetchAdminUsers']),
	},
	computed: {
    checkedCustomerClasses :{
			set(val){this.changeCustomerClassFilter(val)},
			get(){return this.filters.checkedCustomerClasses;}
		},
    active : {
      set(active){this.setFilterActive(active);},
      get(){return this.filters.active;}
    },
    intent : {
      set(intent){this.setFilterIntent(intent);},
      get(){return this.filters.intent;}
    },
    completed : {
      set(completed){this.setFilterCompleted(completed);},
      get(){return this.filters.completed;}
    },
    inactive : {
      set(inactive){this.setFilterInactive(inactive);},
      get(){return this.filters.inactive;}
    },
    redFlag : {
      set(redFlag){this.setFilterRedFlag(redFlag);},
      get(){return this.filters.redFlag;}
    },
    yellowFlag : {
      set(yellowFlag){this.setFilterYellowFlag(yellowFlag);},
      get(){return this.filters.yellowFlag;}
    },
    greenFlag : {
      set(greenFlag){this.setFilterGreenFlag(greenFlag);},
      get(){return this.filters.greenFlag;}
    },
    salesRep : {
      set(salesRep){this.setFilterSalesRep(salesRep);},
      get(){return this.filters.salesRep;}
    },
    delayed : {
      set(delayed){this.setFilterDelayed(delayed);},
      get(){return this.filters.delayed;}
    },
    redLabel(){
      // let duration = JSON.parse(localStorage.RESERVATION_CONFIGURATION).red_flag;
      return " >= " + moment.duration('P25D').asDays() + ` ${this.$i18n.t('reservation.days')}`;
    },
    yellowLabel(){
      // let durationYellow = JSON.parse(localStorage.RESERVATION_CONFIGURATION).yellow_flag;
      // let durationRed = JSON.parse(localStorage.RESERVATION_CONFIGURATION).red_flag;
      return " >= " + moment.duration('P15D').asDays() + " et < " +moment.duration('P25D').asDays() + ` ${this.$i18n.t('reservation.days')}`;
    },
    greenLabel(){
      // let durationYellow = JSON.parse(localStorage.RESERVATION_CONFIGURATION).yellow_flag;
      return " < " + moment.duration('P15D').asDays() + ` ${this.$i18n.t('reservation.days')}`;
    },
    divHeight(){
      return "height :"+(this.window.height-130) + "px"
    },
    width(){
      if(this.window.width > 1024){
        return "30%";
      }else{
        return "100%"
      }
    },
    ...mapState('reservations',['filters']),
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
    ...mapGetters('inventory', ['isMultipleInventorySystem']),
    ...mapState('controlData',['customerClasses']),
	},
  created(){
    this.fetchAdminUsers();
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss" scoped>

// .el-row {
//     margin-bottom: 20px;
//     &:last-child {
//       margin-bottom: 0;
//     }
//   }

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-40px;
  padding-left:40px;
  padding-top:10px;
  border-top:1px solid #E4E7ED
}

.drawer__content {
  margin-left:40px;
  margin-right:20px;
}

@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}


</style>
